<template>
  <div class="my-6 mb-10 pb-10">
    <!-- Event Card -->
    <v-card
      v-for="(event, i) in events"
      :key="i"
      @click="
        $root.routeTo({
          name: 'EventCard',
          params: { no: event.no },
        })
      "
      style="cursor: pointer"
      tile
      elevation="4"
      class="my-4"
    >
      <v-row no-gutters class="d-flex">
        <!-- Event Date -->
        <v-col cols="12" md="2" class="event-banner-col">
          <div
            class="event-banner"
            :style="
              event.base64Logo
                ? { backgroundImage: `url(${url + event.base64Logo})` }
                : {
                    backgroundImage: `url(${require('@/assets/images/picture4.jpg')})`,
                  }
            "
          >
            <div class="event-banner-overlay">
              <div class="event-date-day">
                {{ new Date(event.startDate).getDate() }}
                <sup>{{
                  getOrdinalSuffix(new Date(event.startDate).getDate())
                }}</sup>
              </div>
              <div class="event-date-month">
                {{ months[new Date(event.startDate).getMonth()] }}
              </div>
            </div>
          </div>
        </v-col>

        <!-- Event Details -->
        <v-col cols="12" md="1">
          <div class="ml-3 mt-4 mr-n2">
            <CPDbadge :cpd-points="event.cpdHours" />
          </div>
        </v-col>
        <v-col cols="12" md="7">
          <div class="mx- mt-5">
            <div class="dateText d-md-block d-sm-flex flex-row justify-center">
              <span class="font-weight-medium">{{ event.description }}</span>
              |
              <span class="mr-2 text-body-1">
                From {{ getFormattedDate(event.startDate) }} To
                {{ getFormattedDate(event.endDate) }}
              </span>
            </div>
            <div class="d-md-block d-sm-flex flex-row justify-center">
              <v-chip-group column>
                <v-chip color="secondary" class="white--text">
                  {{ event.eventType }}
                </v-chip>
                <v-chip color="secondary" class="white--text">
                  {{ event.location }}
                </v-chip>
              </v-chip-group>
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="2" class="pa-3">
          <div
            class="d-flex flex-row justify-center items-center"
            style="margin-top: 20%"
          >
            <v-btn
              @click="
                $root.routeTo({
                  name: 'EventCard',
                  params: { no: event.no },
                })
              "
              color="primary"
            >
              <v-icon left>book_online</v-icon>
              View details
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>
<script>
import eventMixin from "../eventMixin";
import CPDbadge from "./CPDbadge.vue";

export default {
  name: "EventList",
  components: {
    CPDbadge,
  },
  props: {
    events: {
      type: Array,
      required: true,
    },
  },
  mixins: [eventMixin],
  data() {
    return {
      days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      url: process.env.VUE_APP_TEMP_URL,
    };
  },
  computed: {
    cpd_caption() {
      return process.env.VUE_APP_CPD_CAPTION;
    },
  },
};
</script>

<style>
.event-banner-col {
  padding: 0;
}

.event-banner {
  position: relative;
  height: 100%;
  min-height: 140px;
  background-size: cover;
  background-position: center;
  border-radius: 4px 0 0 4px;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
}

/* Fallback gradient */
.event-banner.no-image {
  background: linear-gradient(180deg, #ce1b28 0%, #087f23 100%);
}

/* Overlay */
.event-banner-overlay {
  width: 100%;
  padding: 12px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.15));
  text-align: center;
}

/* Date styling */
.event-date-day {
  color: #fff;
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1;
}

.event-date-day sup {
  font-size: 0.7rem;
}

.event-date-month {
  color: #fff;
  font-size: 0.85rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  margin-top: 2px;
}

/* Hover polish */
.v-card:hover .event-banner {
  transform: scale(1.02);
  transition: transform 0.2s ease;
}

/* Mobile */
@media (max-width: 960px) {
  .event-banner {
    min-height: 180px;
    border-radius: 4px 4px 0 0;
  }
}
</style>
